/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Category_QuestionInputs */



/**
* | output |
* | --- |
* | "Question" |
*
* @param {Feedback_Category_QuestionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_category_question = /** @type {((inputs?: Feedback_Category_QuestionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Category_QuestionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Question")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pregunta")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Pergunta")
	if (locale === "it") return /** @type {LocalizedString} */ ("Domanda")
	return /** @type {LocalizedString} */ ("Question")
});